var path = 'app/scripts/modules/appengine/pipeline/stages/destroyAsg/destroyAsgStepLabel.html';
var html = "<span class=\"task-label\">\n  Destroy Server Group:\n  {{step.context.serverGroupName}}\n  ({{step.context.region}})\n</span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/appengine/pipeline/stages/destroyAsg/destroyAsgStepLabel.html
// module id = 1251
// module chunks = 0